import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { SecurityService } from './security.service';

@Directive({
  selector: '[accessStyling]',
  standalone: false,
})
export class AccessStylingDirective {
  @Input('accessStyling') set permissionsStyleConfig(value: { [csRule: string]: string[] }) {
    if (value) {
      Object.keys(value).forEach((key) => {
        const permissions = value[key];
        if (this.security.hasAccess(permissions)) {
          this.renderer.addClass(this.elementRef.nativeElement, key);
        } else {
          this.renderer.removeClass(this.elementRef.nativeElement, key);
        }
      });
    }
  }

  constructor(
    private readonly security: SecurityService,
    private readonly elementRef: ElementRef,
    private readonly renderer: Renderer2,
  ) {}
}
